import {
  LOADING_ARRAY,
  LIST_UNIT_DOOR_ACCESS_IDS_REQUEST,
  LIST_UNIT_DOOR_ACCESS_IDS_RESPONSE,
  REMOVE_UNIT_DOOR_ACCESS_RESPONSE,
  ADD_UNIT_DOOR_ACCESSES_RESPONSE,
  LOGOUT_RESPONSE,
} from '../constants'

// unitId -> [doorAccessIds, ...]
const initialState = {}

export default function update(state = initialState, action) {
  switch (action.type) {
    case LIST_UNIT_DOOR_ACCESS_IDS_REQUEST:
      return {
        ...state,
        [action.unitId]: state[action.unitId] || LOADING_ARRAY,
      }

    case LIST_UNIT_DOOR_ACCESS_IDS_RESPONSE:
      return {
        ...state,
        [action.unitId]: action.accessIds || [],
      }

    case REMOVE_UNIT_DOOR_ACCESS_RESPONSE:
      return {
        ...state,
        [action.unitId]: state[action.unitId].filter((id) => id !== action.accessId),
      }

    case ADD_UNIT_DOOR_ACCESSES_RESPONSE:
      return {
        ...state,
        [action.unitId]: action.accessIds,
      }

    case LOGOUT_RESPONSE:
      return initialState
    default:
      return state
  }
}
